import { ApiModel, ApiModelVersion } from 'types/swagger/clarifai-api';

export const constructModelUrl = (model?: ApiModel) => {
  const host = typeof window !== 'undefined' ? window?.location?.origin : 'https://clarifai.com';
  const userIdParam = encodeURIComponent(model?.user_id || '');
  const appIdParam = encodeURIComponent(model?.app_id || '');
  const modelIdParam = encodeURIComponent(model?.id || '');
  return `${host}/${userIdParam}/${appIdParam}/models/${modelIdParam}`;
};

export const constructModelUrlWithVersion = (model?: ApiModel, version?: ApiModelVersion) => {
  const host = typeof window !== 'undefined' ? window?.location?.origin : 'https://clarifai.com';
  const userIdParam = encodeURIComponent(model?.user_id || '');
  const appIdParam = encodeURIComponent(model?.app_id || '');
  const modelIdParam = encodeURIComponent(model?.id || '');
  const versionIdParam = encodeURIComponent(version?.id || model?.model_version?.id || '');
  return `${host}/${userIdParam}/${appIdParam}/models/${modelIdParam}/versions/${versionIdParam}`;
};
